import React from 'react';
import { useSwipeGesture } from '../hooks/useSwipeGesture';
import LazyImage from './LazyImage';
import { config } from '../config/environment';

interface Produto {
  id: number;
  nome: string;
  descricao: string;
  preco: number;
  imagem_url?: string;
  codigo?: string;
  tempo_preparo: number;
}

interface ProductCardCompactProps {
  produto: Produto;
  isDestaque?: boolean;
  onSelect: () => void;
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  swipeEnabled?: boolean;
}

/**
 * Versão compacta do ProductCard para mobile
 * Mostra apenas informações essenciais: nome, código, preço
 */
const ProductCardCompact: React.FC<ProductCardCompactProps> = ({
  produto,
  isDestaque = false,
  onSelect,
  onSwipeLeft,
  onSwipeRight,
  swipeEnabled = false
}) => {
  const swipeHandlers = useSwipeGesture({
    onSwipeLeft: onSwipeLeft,
    onSwipeRight: onSwipeRight,
    enabled: swipeEnabled
  });

  return (
    <div
      {...(swipeEnabled ? swipeHandlers : {})}
      className={`bg-gradient-to-br rounded-lg p-3 border transition-all duration-200 cursor-pointer touch-manipulation active:scale-95 shadow-md hover:shadow-lg min-h-[70px] from-gray-700/50 to-gray-600/50 border-gray-600/30 hover:border-orange-500/50 ${
        isDestaque ? 'ring-2 ring-orange-500 ring-offset-1 ring-offset-gray-800' : ''
      }`}
      onClick={onSelect}
    >
      <div className="flex items-center gap-2">
        {/* Imagem pequena */}
        {produto.imagem_url && (
          <div className="w-10 h-10 bg-gray-600 rounded-lg overflow-hidden flex-shrink-0">
            <LazyImage
              src={produto.imagem_url}
              alt={produto.nome}
              className="w-full h-full object-cover"
              baseUrl={config.api.baseUrl}
            />
          </div>
        )}
        
        {/* Informações principais */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 mb-0.5 flex-wrap">
            <h3 className="text-sm font-bold text-white truncate">
              {produto.nome}
            </h3>
            {produto.codigo && (
              <span className="bg-purple-500/20 text-purple-300 text-xs px-1.5 py-0.5 rounded border border-purple-500/30 flex-shrink-0 font-mono">
                {produto.codigo}
              </span>
            )}
          </div>
          <div className="flex items-center justify-between">
            <span className="text-orange-400 font-bold text-sm">
              R$ {produto.preco.toFixed(2)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCardCompact;
